import Config from 'config';
import { sessionManager, vueExports } from 'vue-infra';
import { TABS } from '@/common/consts';
import { FEATURES, PRIVILEGES } from '@/store/modules/data/logged-in-user/consts';

// Components
const MyConnectionsPage = () => import('@/components/my-connections/my-connections-page.vue');
const AllConnectionsPage = () => import('@/components/all-connections/all-connections-page.vue');
const AllTasksPage = () => import('@/components/all-tasks/all-tasks-page.vue');
const AgentListPage = () => import('@/components/agent-list/agent-list-page.vue');
const MainLayout = () => import('@/components/layout/main-layout.vue');

const routes = [{
  path: `/aw/${TABS.MY_CONNECTIONS}/:id?`,
  name: TABS.MY_CONNECTIONS,
  components: { aw: MyConnectionsPage },
  meta: { layout: MainLayout },
}, {
  // We have to have these (origin and filteredConversationId) here
  // because vue-router 4.x.x filters out params that are not part of the path
  path: `/aw/${TABS.ALL_CONNECTIONS}/:origin?/:filteredConversationId?`,
  name: TABS.ALL_CONNECTIONS,
  // We are forced to use `shallowRef` because, for some reason,
  // the imported component (only this component, or one of its children) becomes reactive.
  // At which point, we see the following warning in the console
  // shallowRef proved to be, as of right now, to easiest "solution"
  /***
  [Vue warn]: Vue received a Component that was made a reactive object.
  This can lead to unnecessary performance overhead and should be avoided
  by marking the component with `markRaw` or using `shallowRef` instead of `ref`.
  ***/
  components: { aw: vueExports.shallowRef(AllConnectionsPage) },
  props: { aw: true },
  meta: { layout: MainLayout },
  beforeEnter(to, from, next) {
    const hasMessagingHistoryPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.MESSAGING_HISTORY_PRIVILEGE));
    const hasViewActiveConnections = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ACTIVE_CONNECTIONS));
    if (hasViewActiveConnections && hasMessagingHistoryPrivilege) {
      next();
    } else {
      next(false);
    }
  },
}, {
  path: `/aw/${TABS.ALL_TASKS}`,
  name: TABS.ALL_TASKS,
  components: { aw: AllTasksPage },
  meta: { layout: MainLayout },
  beforeEnter(to, from, next) {
    const hasHandleFalseResponsesFeature = sessionManager.getFeaturePropertyState(FEATURES.HANDLE_FALSE_RESPONSES);
    const hasAgentAnnotationsFeature = sessionManager.getFeaturePropertyState(FEATURES.HANDLE_INTENT_ANNOTATIONS);
    const hasMessagingHistoryPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.MESSAGING_HISTORY_PRIVILEGE));
    const hasViewAllTasksPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.VIEW_ALL_TASKS));
    const isLPA = sessionManager.isLPA();
    if (
      (hasAgentAnnotationsFeature || hasHandleFalseResponsesFeature) &&
      (hasViewAllTasksPrivilege || (isLPA && hasMessagingHistoryPrivilege))
    ) {
      next();
    } else {
      next(false);
    }
  },
}, {
  path: `/aw/${TABS.AGENT_LIST}`,
  name: TABS.AGENT_LIST,
  components: { aw: AgentListPage },
  meta: { layout: MainLayout },
}, {
  path: '/aw/:pathMatch(.*)?',
  name: 'default',
  redirect: { path: `/${Config.applicationName}/${TABS.MY_CONNECTIONS}` },
  meta: { layout: MainLayout },
}];

export default routes;
